import { formatLegDepartureDate, formatLegDuration } from "./date";

/**
 * Formats an array of journey legs with dates, durations, and fuel stops.
 * @param {Array} legs - Array of leg objects
 * @param {Object} options - Formatting options
 * @param {string|number} [options.duration] - Fallback duration if leg doesn't have one
 * @param {number} [options.fuelStop] - Fallback fuel stop count if leg doesn't have one
 * @param {boolean} [options.shortYear=false] - Whether to shorten year in dates
 * @returns {Array} Array of formatted leg objects
 */
const formatJourneyLegs = (legs, { duration, fuelStop, shortYear = true } = {}) => {
    if (!legs || !Array.isArray(legs)) return [];

    return legs.map((leg, index) => {
        const formattedDepartureDate = formatLegDepartureDate(leg.departureDate, shortYear);
        const legDurationFormatted = formatLegDuration(leg.duration || duration);
        const legFuelStop = leg.fuelStop !== undefined ? leg.fuelStop : fuelStop && index === 0 ? fuelStop : 0;

        return {
            ...leg,
            formattedDepartureDate,
            duration: legDurationFormatted,
            fuelStop: legFuelStop,
        };
    });
};

export { formatJourneyLegs };
